import { codeSplit, Controller, FetchOptions } from 'bernie-core';
import { PageData } from 'bernie-http';
import { helpCenterPageIdentifier } from '../common/constant';

// "controllers" map directly to react-router routes, can additionally provide data
export class HelpCenterController implements Controller {
  public pageId = helpCenterPageIdentifier;
  public path = '/helpcenter';
  public routeName = 'helpcenter';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "helpcenter" */ '../views/helpcenter'));
  public exact = true;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public fetch(options: FetchOptions): Promise<any> {
    return Promise.resolve({ title: 'Help Center', pageId: this.pageId });
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Help Center', pageId: this.pageId, appName: 'Help Center' }) as Promise<PageData>;
  }
}
